import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { Table, Button, Input, Tabs, Tooltip } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import { CloseOutlined, DeleteOutlined } from '@ant-design/icons'
const { TabPane } = Tabs;

import { 
  getClassifyData,
  getDictList
} from '../../actions/publish'

const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "61px",
      padding: "18px 24px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#0F25D1 !important",
      borderRadius: "2px !important",
    },
    container: {
      paddingTop: '20px'
    },
    dateFilter: {
      width: "236px",
      padding: "8px",
    },
    defaultFilter: {
      width: "196px",
      padding: "8px",
    },
    btnLine: {
      marginTop: "8px",
      display: 'flex',
      justifyContent: 'space-between'
    },
    select: {
      width: '100%'
    },
    tableContainer: {
      '& .ant-table-cell-row-hover': {
        background: '#f0fbff !important'
      },
      '& td.ant-table-column-sort': {
        background: '#f0fbff !important'
      }
    },
    labelBox: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      padding: '10px 0 0',
      '& .ant-tabs': {
        width: '100%',
        '& .ant-tabs-nav': {
          marginBottom: '0 !important'
        }
      }
    },
    label: {
      height: "25px",
      margin: "0 10px 10px 0",
      lineHeight: "23px",
      fontSize: "14px",
      color: "#000",
      fontWeight: "400",
      padding: "0 12px",
      display: "inline-block",
      border: "1px solid #ddd",
      borderRadius: "4px",
      cursor: "pointer",
      "&.active": {
        color: "#0F25D1",
        borderColor: "#0F25D1",
      },
    }
  };
};

class Classify extends Component {
  constructor(props){
    super(props);
  }

  state = {
    loading: true,
    filteredInfo: null,
    filterForm: {},
    filterDropdownVisible: false,
    tabList: [ ],
    columns: [],
    inputBak: '',
    valueBak: '',
    data: [],
    tabIndex: 0,
    updateTime: '',
    searchHistoryList: [],
    form: {},
    defaultForm: { // 默认值
      KeyWord: "",
      ProductName: "",
      ProductDesc: "",
      IntendedUse: "",
      ClassificationCode: "",
      ManagementCategory: "",
      Source: "",
    },
    labelObj: { // 筛选项key - label对应关系
      KeyWord: '关键词',
      ProductName: '产品名称',
      ProductDesc: '产品描述',
      IntendedUse: '预期用途',
      ClassificationCode: '分类编码',
      ManagementCategory: '管理类别',
      Source: '信息来源',
    },
    labelListObj: { },
    selectKeys: [],
    tabKey: '',
    page: {
      page: 1,
      pageSize: 10
    },
    total: 0,
    scrollObj: {
      x: 1560,
      y: 500
    },
    paginationObj: {
      showSizeChanger: true,
      allTotal: 0,
      total: 0,
      showTotal: (total, range) => {
        return '共【' + this.state.paginationObj.total + '】条数据'
        // return '当前已筛选出【' + this.state.paginationObj.total + '】条，总数据量【' + this.state.paginationObj.allTotal + '】条'
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize)
      },
    }
  };

  getTableHeight = () => {
    // 计算表格高度
    let height = window.innerHeight
    let lineHeight = document.getElementById('searchBar').offsetHeight
    this.setState({
      scrollObj: {
        x: 1560,
        y: height - lineHeight - 260
      }
    })
  }

  componentDidMount() {
    this.getTableHeight()
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })

    let search = decodeURI(this.props.location.search)
    let params = search.substring(1).split('&')
    let obj = params.find(v => {
      return v.indexOf('keyword=') == 0
    })
    if (obj) {
      let urlKeyword = obj.split('=')[1]
      this.setState({
        form: {
          ...this.state.form,
          KeyWord: urlKeyword,
        },
      })
    }

    this.initTab()
  }

  resetForm = () => {
    this.setState({
      form: {
        KeyWord: "",
        ProductName: "",
        productDesc: "",
        IntendedUse: "",
        ClassificationCode: "",
        ManagementCategory: "",
        Source: "",
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => this.initData())
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => this.initData())
  }

  searchForm = () => {
    this.initData()
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (form[key] && form[key].length > 0) {
        let showValue = form[key]
        let label = ''
        if (key == 'RatifyDate') {
          showValue = `${showValue[0].format("YYYY-MM-DD")} - ${showValue[1].format("YYYY-MM-DD")}`
        }
        if (this.state.selectKeys.indexOf(key) > -1) {
          label = this.state[this.state.labelListObj[key]].find(v => {
            return v.ID == showValue
          }).Name
        }
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: label || showValue,
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = label || showValue
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    })
  }

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  initTab =() => {
    // 类型
    getDictList({
      Type: 'classification_definition_types'
    }).then(res => {
      if (!res.Error) {
        this.setState({
          tabList: res.DataList,
          tabKey: res.DataList[0].ID
        }, () => {
          this.initData()
        })
      }
    })
  }

  initData = () => {
    
    let param =  Object.assign({
      KeyWord: this.state.form.KeyWord || '',
      productName: this.state.form.ProductName || '',
      productDesc: this.state.form.ProductDesc || '',
      intendedUse: this.state.form.IntendedUse || '',
      classificationCode: this.state.form.ClassificationCode || '',
      managementCategory: this.state.form.ManagementCategory || '',
      source: this.state.form.Source || '',
    }, this.state.page)
    param.classificationDefinitionTypes = this.state.tabKey
    getClassifyData(param).then(res => {
      if (!res.Error && res.DataList) {
        let newPaginationObj = this.state.paginationObj
        newPaginationObj.total = res.DataNumber
        newPaginationObj.allTotal = res.UnfilteredAllDataNumber
        this.setState({
          data: res.DataList.map(v => {
            v.key = v.ID
            return v
          }),
          paginationObj: newPaginationObj,
          loading: false
        }, () => {
          this.getColumns()
        })
      } else {
        this.setState({
          loading: false
        })
      }
    })
  }


  getColumns = () => {
    let classes = this.props.classes

    let columns = [
      {
        title: '产品名称',
        dataIndex: 'ProductName',
        key: 'ProductName',
        width: 200,
        
      },
      {
        title: '产品描述',
        width: 530,
        dataIndex: 'ProductDesc',
        key: 'ProductDesc',
        ellipsis: {
          showTitle: false,
        },
        render: (_, record) => {
          let content = record.ProductDesc || ''
          return   <Tooltip placement="topLeft" title={content}>
            <span >{content}</span>
          </Tooltip>
        },
      },
      {
        title: '预期用途',
        width: 530,
        dataIndex: 'IntendedUse',
        key: 'IntendedUse',
        ellipsis: {
          showTitle: false,
        },
        render: (_, record) => {
          let content = record.IntendedUse || ''
          return   <Tooltip placement="topLeft" title={content}>
            <span >{content}</span>
          </Tooltip>
        },
      },
      {
        title: '分类编码',
        dataIndex: 'ClassificationCode',
        width: 100, 
        key: 'ClassificationCode',
      },
      {
        title: '管理类别',
        dataIndex: 'ManagementCategory',
        width: 100, 
        key: 'ManagementCategory',
      },
      {
        title: '信息来源',
        dataIndex: 'Source',
        width: 100, 
        key: 'Source',
      },
    ]

    this.setState({
      columns: columns
    })
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      loading: true
    }, () => {
      this.getColumns()
      this.initData()
    });
  };

  handleSort = () => {}

  clearFilters = () => {
    this.setState({ filteredInfo: null });
  };

  clearAll = () => {
    this.setState({
      filteredInfo: null,
      page: {
        page: 1,
        pageSize: 10
      },
      form: {},
      selectLabel: '',
      selectType: '',
      loading: true
    }, () => {
      this.getColumns()
      this.initData()
    });
  };

  handleClickLabel = (data) => {
    if (this.state.selectLabel == data.Name) {
      this.setState({
        selectLabel: '',
        selectType: '',
        loading: true
      }, () => this.initData())
    } else {
      this.setState({
        selectLabel: data.Name,
        selectType: data.SearchType,
        loading: true
      }, () => this.initData())
    }
  }

  handleReset = (clearFilters) => {
    clearFilters()
  }


  handleSearch = (key, value, confirm) => {
    let newForm = this.state.form
    newForm[key] = value
    this.setState({
      form: newForm,
      loading: true
    }, () => this.initData())
    confirm()
  }

  pageChange = (page, pageSize) => {
    if (page == this.state.page.page && pageSize == this.state.page.pageSize) {
      return
    }
    this.setState({
      page: {
        page: page,
        pageSize: pageSize
      },
      loading: true
    }, () => this.initData())
  }

  changeTab = (data, i) => {
    this.setState({
      tabIndex: i,
      tabKey: data.ID,
      loading: true,
    }, () => {
      this.initData()
    })
  }

  render() {
    const classes = this.props.classes;

    return (
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            <div className="form-item">
              <div className="form-label">关键词</div>
              <Input  value={this.state.form.KeyWord}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'KeyWord')} 
                placeholder="请输入关键词"/>
            </div>
            <div className="form-item">
              <div className="form-label">产品名称</div>
              <Input  value={this.state.form.ProductName}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'ProductName')} 
                placeholder="请输入产品名称"/>
            </div>
            <div className="form-item">
              <div className="form-label">产品描述</div>
              <Input  value={this.state.form.ProductDesc}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'ProductDesc')} 
                placeholder="请输入产品描述"/>
            </div>
            <div className="form-item">
              <div className="form-label">预期用途</div>
              <Input  value={this.state.form.IntendedUse}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'IntendedUse')} 
                placeholder="请输入预期用途"/>
            </div>
            <div className="form-item">
              <div className="form-label">分类编码</div>
              <Input  value={this.state.form.ClassificationCode}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'ClassificationCode')} 
                placeholder="请输入分类编码"/>
            </div>
            <div className="form-item">
              <div className="form-label">管理类别</div>
              <Input  value={this.state.form.ManagementCategory}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'ManagementCategory')} 
                placeholder="请输入管理类别"/>
            </div>
            <div className="form-item">
              <div className="form-label">信息来源</div>
              <Input  value={this.state.form.Source}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'Source')} 
                placeholder="请输入信息来源"/>
            </div>
            

          </div>

          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>

        <div className="common-main">
          <div className="common-main-search" id="searchBar">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">分类界定</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value">{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
           
            <Grid container className={classes.container} id="tableContainer">
              <Table 
                className={classes.tableContainer}
                columns={this.state.columns} 
                loading={this.state.loading} 
                dataSource={this.state.data} 
                onChange={this.handleChange} 
                pagination={this.state.paginationObj}
                scroll={this.state.scrollObj}
                bordered
                />
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(Classify));
